import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  margin: 10px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  height: 245px;
  width: 360px;
  position: relative;
  box-shadow: rgb(220, 220, 220) 0px 0px 15px;
  overflow: hidden;

  ${mediaMaxWidth.smallDesktop} {
    margin: 10px auto;
    width: 650px;
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 20px);
  }

  ${mediaMaxWidth.phone} {
    height: 240px;
  }
`;

export const Title = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  display: flex;

  .__react_component_tooltip {
    text-align: center;
    font-weight: 400;
  }

  ${mediaMaxWidth.phone} {
    padding: 5px;
    font-size: 0.9em;
  }
`;

export const TitleText = styled.div`
  ${mediaMaxWidth.phone} {
    width: calc(100vw - 55px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const Tooltip = styled.div`
  margin: 0 5px;
  cursor: pointer;
  display: flex;
  align-items: center;

  svg {
    font-size: 0.85em;
    color: rgb(187, 187, 187);
    transition: all 0.1s ease-in-out 0s;
  }

  ${mediaMaxWidth.smallDesktop} {
    display: none;
  }
`;

interface IBodyProps {
  noData: boolean;
}

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: ${(props: IBodyProps) =>
    props.noData ? "10px 30px" : "10px 10px 0 10px"};
  justify-content: ${(props: IBodyProps) => props.noData && "center"};
  align-items: ${(props: IBodyProps) => props.noData && "center"};
  font-size: ${(props: IBodyProps) => props.noData && "0.95em"};
  text-align: ${(props: IBodyProps) => props.noData && "center"};

  ${mediaMaxWidth.phone} {
    padding: ${(props: IBodyProps) => props.noData && "85px 30px !important"};
  }
`;

export const Paragraph = styled.p`
  font-style: italic;
`;

export const Technique = styled.div`
  display: flex;
  height: 44.25px;
  align-items: center;
  font-size: 0.95em;

  svg {
    color: #27ae60;
  }
`;

export const TechniqueText = styled.div`
  padding-left: 15px;
  width: 305px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${mediaMaxWidth.smallDesktop} {
    width: 595px;
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 75px);
  }
`;

export const SeeMore = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${mediaMaxWidth.smallDesktop} {
    height: 60px;
  }
`;

export const SeeMoreButton = styled.div`
  cursor: pointer;
  text-decoration: underline;
  font-size: 0.85em;
  text-transform: capitalize;

  &:hover {
    color: #79D9D9;
  }
`;
